import { SystemProps } from "@chakra-ui/react";

import { TOptionGroupItem, TMultipleLinesConfig } from "../types";
import createRotatingIndex from "./createRotatingIndex";

type TMultpleRowsMapperArgs = {
  options: TOptionGroupItem[];
  lines: TMultipleLinesConfig[];
};

const mapProps =
  ({ height, width }: { height: SystemProps["height"]; width: SystemProps["width"] }) =>
  (option: TOptionGroupItem) => ({
    ...option,
    ...(height && { height }),
    ...(width && { width, flexBasis: width }),
  });

const mapToMultipleRows = ({ options, lines }: TMultpleRowsMapperArgs): TOptionGroupItem[][] => {
  if (!lines.length) {
    throw new Error("OptionButtonGroup that consists multiple lines requires 'lines' configurations");
  }

  const rowsList: TOptionGroupItem[][] = [];

  let start = 0;
  const { getIndex, rotateIndex } = createRotatingIndex(lines.length - 1);

  while (options.length > start) {
    const { length, height, width } = lines[getIndex()];
    const row = options.slice(start, start + length).map(mapProps({ height, width }));
    start += length;
    rowsList.push(row);
    rotateIndex();
  }

  return rowsList;
};

export default mapToMultipleRows;
